#@import BookingV2.gliveDealBookerInit

window.GliveBookingWrapper ?= {}

GliveBookingWrapper.init = ({gliveBooker}, done) ->
  return done() unless gliveBooker?.isGliveDeal
  $ ->
    BookingV2.gliveDealBookerInit(false, gliveBooker, done)



// WEBPACK FOOTER //
// ./modules/deal/frontend/glive_booking_wrapper.coffee